import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchCheckLogin,
  fetchLogin,
  fetchRegister,
  fetchForgotPassword,
} from "./authAPI";
import { getBrowserInfo } from "helpers/browserDetection";

const initialState = {
  value: null,
  status: "idle",
  error: "",
  tosRegister: false,
  status_login: false,
  twoFactorEnabled: false,
  browserInfo: null,
  userid: "",
  data_login: "",
};

export const checkLogin = createAsyncThunk("auth/checkLogin", async () => {
  const response = await fetchCheckLogin();
  return response;
});

export const userLogin = createAsyncThunk(
  "auth/login",
  async (loginCredential) => {
    const response = await fetchLogin(loginCredential);
    return response;
  }
);

export const userForgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (email) => {
    const response = await fetchForgotPassword(email);
    return response;
  }
);

export const userRegister = createAsyncThunk(
  "auth/register",
  async (registerCredential) => {
    const response = await fetchRegister(registerCredential);
    return response;
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTosRegister: (state, action) => {
      state.tosRegister = action.payload;
    },
    resetStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        if (action.payload.error || action.payload.code === 400) {
          state.status = "error";

          // Handle different error structures
          if (action.payload.message) {
            state.error = action.payload.message;
          } else if (action.payload.error && typeof action.payload.error === 'string') {
            state.error = action.payload.error;
          } else if (action.payload.error && action.payload.error.message) {
          state.error = action.payload.error.message;
          } else {
            state.error = "Login gagal. Email atau password salah.";
          }
          return;
        }

        state.status = "idle";

        // Get browser info
        state.browserInfo = getBrowserInfo();

        if (action.payload.data && action.payload.data.result === "twoFactorEnabled") {
          state.twoFactorEnabled = true;
        } else {
          // Update login status instead of reloading
          if (action.payload.code === 200) {
            state.status_login = true;
            // Set temporary data, will be updated by checkLogin dispatch
            state.data_login = action.payload.data;
          }
        }
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(userRegister.pending, (state) => {
        state.status = "loading";
      })
      .addCase(userRegister.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.status = "error";
          state.error = action.payload.error.message;
          return;
        }
        state.status = "idle";
        state.redirectUrl = action.payload.data.redirect_url;
      })
      .addCase(userRegister.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(userForgotPassword.pending, (state) => {
        state.status = "loading";
      })
      .addCase(userForgotPassword.fulfilled, (state, action) => {
        if (action.payload.error || action.payload.success === false) {
          state.status = "error";
          
          // Handle different error structures from forgotPasswordAccount.php
          if (action.payload.error && typeof action.payload.error === 'string') {
            state.error = action.payload.error;
          } else if (action.payload.message) {
          state.error = action.payload.message;
          } else if (action.payload.error && action.payload.error.message) {
            state.error = action.payload.error.message;
          } else {
            state.error = "Gagal mengirim email reset password";
          }
        } else {
          state.status = "fulfilled";
          state.error = "";
        }
      })
      .addCase(userForgotPassword.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(checkLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkLogin.fulfilled, (state, action) => {
        state.status = "idle";
        if (!action.payload.error) {
          state.data_login = action.payload.data;
          state.status_login = true;
        } else {
          state.status_login = false;
        }
      })
      .addCase(checkLogin.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      });
  },
});

export default authSlice.reducer;
export const { setTosRegister, resetStatus } = authSlice.actions;
